import { render, staticRenderFns } from "./CommonChart.vue?vue&type=template&id=c6dc109a&scoped=true&"
import script from "./CommonChart.vue?vue&type=script&lang=js&"
export * from "./CommonChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dc109a",
  null
  
)

export default component.exports